import { cx } from '@hrworks/design-system/functions';

import { S } from './HelpText.styles';
import type { HelpTextProps } from './HelpText.types';

export const HelpText = ({
  helpText,
  validationMessage,
  validationState,
  className,
  size = 'medium',
  disabled,
  ...otherProps
}: HelpTextProps) => {
  if (!helpText && !(validationMessage && validationState)) {
    return null;
  }

  return (
    <S.HelpTextContainer
      className={cx(S.cls.HelpTextContainer, className)}
      $size={size}
      validationState={validationState}
      validationMessage={validationMessage}
      $disabled={disabled}
      title={validationMessage}
      {...otherProps}
    >
      {validationState && validationMessage ? validationMessage : helpText}
    </S.HelpTextContainer>
  );
};
